import { STRINGS } from '../../constants';
import apiCaller from '../http';
import URLS from '../urls';

const checkPaymentStatus = async (visitId, setError, saveServiceStatus, logoutHandler) => {
  await apiCaller
    .get(`${URLS.CHECK_PAYMENT_STATUS_WORKSHOP}${visitId}/`)
    .then((resp) => {
      setError(null);
      saveServiceStatus(resp?.data);
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400Text);
      }
    });
};

export default checkPaymentStatus;
